/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class BrandingUiInfoKeys {
    static APP_ICONS = {
        NEW_ICON: 'newIcon',
    };

    static APP_IMAGES = 'appImages';

    static CATCH_UP = 'catchupName';

    static CUSTOMER_SUPPORT_NAME = 'customerSupportName';

    static DEVICE_NAME = 'deviceName';

    static DEVICE_NAME_SHORT = 'deviceNameShort';

    static DISPLAY_NAME = 'displayName';

    static DISTRIBUTOR_NAME = 'distributorName';

    static EPG_LOOK_BACK_HOURS = 'epgLookBackHours';

    static IMAGE = 'image';

    static MANUFACTURER_NAME = 'manufacturerName';

    static PHONE_CUSTOMER_SUPPORT_NUMBER = 'phoneCustomerSupportNumber';

    static START_OVER = 'startoverName';

    static URL_CUSTOMER_SUPPORT = 'urlCustomerSupport';

    static URL_ERROR = 'urlError';

    static URL_PRIVACY = 'urlPrivacy';

    static YOUR_CABLE_PROVIDER = 'yourCableProvider';
}
